import { Quote } from "lucide-react"

import { FeatureCard } from "./feature-card"
import type { DashboardPhrase } from "@/types"

interface PhrasesCardProps {
  phrases: DashboardPhrase[]
  animationDelay?: number
}

export function PhrasesCard({
  phrases,
  animationDelay = 0,
}: PhrasesCardProps) {
  return (
    <FeatureCard
      title="Phrases"
      icon={Quote}
      iconColor="text-sky-600 dark:text-sky-400"
      iconBgColor="bg-sky-100 dark:bg-sky-900/30"
      href="/phrases"
      animationDelay={animationDelay}
    >
      {phrases.length === 0 ? (
        <div className="py-4 text-center">
          <p className="text-muted-foreground text-sm">No phrases yet</p>
          <p className="text-muted-foreground mt-1 text-xs">
            Browse useful Thai phrases
          </p>
        </div>
      ) : (
        <ul className="space-y-3">
          {phrases.map((phrase) => (
            <li
              key={phrase.slug}
              className="bg-muted/30 hover:bg-muted/50 rounded-lg px-3 py-2 transition-colors"
            >
              <p className="text-foreground text-sm font-medium">
                {phrase.content}
              </p>
              {phrase.romanization && (
                <p className="text-muted-foreground mt-0.5 text-xs">
                  {phrase.romanization}
                </p>
              )}
            </li>
          ))}
        </ul>
      )}
    </FeatureCard>
  )
}
